import React from "react";
import PropTypes from "prop-types";

import "./style.scss";

const UserPersonalParamList = ({ children, ...rest }) => {
  return (
    <div className="personal-info" {...rest}>
      <div className="personal-info__wrapper">{children}</div>
    </div>
  );
};

UserPersonalParamList.propTypes = {
  children: PropTypes.any,
};

export default UserPersonalParamList;
